// extracted by mini-css-extract-plugin
export var actionButton = "_hd-0";
export var actionMenuContainer = "_hd-i";
export var bubble = "_hd-2";
export var bubbleActionMenu = "_hd-j";
export var bubbleContext = "_hd-6";
export var bubbleItems = "_hd-7";
export var customer = "_hd-3";
export var divider = "_hd-8";
export var fileList = "_hd-9";
export var hiddenComment = "_hd-o";
export var infoAbove = "_hd-a";
export var internal = "_hd-4";
export var lightActionButton = "_hd-1";
export var link = "_hd-b";
export var merchant = "_hd-5";
export var message = "_hd-c";
export var profilePicture = "_hd-e";
export var quillToolbarContainer = "_hd-f";
export var senderDate = "_hd-g";
export var senderDateCustomer = "_hd-h";
export var senderName = "_hd-d";
export var time = "_hd-k";
export var uploadedImage = "_hd-l";
export var username = "_hd-m";
export var xsmall = "_hd-n";